module.exports = "/public/images/1f12ee071fe0a96d6bc098d8bcfcdbf7.svg";